module.exports = __webpack_public_path__ + "img/activityone.a0aea08a.png";